/**
 * Route for `fraud-report-slicing-campaign-publisher-geo-device`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { FraudReportSlicingCampaignPublisherGeoDevicePage } from "../features/fraud-report-slicing-campaign-publisher-geo-device/FraudReportSlicingCampaignPublisherGeoDevicePage";

export const fraudReportSlicingCampaignPublisherGeoDeviceRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/fraud-report-slicing-campaign-publisher-geo-device",
	component: FraudReportSlicingCampaignPublisherGeoDevicePage,
});

export default fraudReportSlicingCampaignPublisherGeoDeviceRoute;
